import camelizeKeys from 'lib/camelizeKeys'

import reduxStore from 'lib/reduxStore'
import {
  ejectRequestInterceptor,
  ejectResponseInterceptor,
  setRequestInterceptors,
  setResponseInterceptors
} from 'lib/api/restClient'
import { allRoutesConfig } from 'lib/routesConfig'
import { reauthenticate } from 'lib/reauthenticate'
import { RootState } from 'redux/toolkit/store'
import logger from '../logger'

export async function responseDataInterceptor(data: any) {
  if (data.config.headers.isToolkitCompatible) {
    return {
      ...data,
      data: {
        ...camelizeKeys(data.data)
      }
    }
  }

  return data
}

/* eslint-disable no-param-reassign */
async function requestInterceptor(requestConfig: any) {
  const authStore = reduxStore.getState().auth
  const accessToken = authStore?.accessToken

  if (accessToken?.length) {
    requestConfig.headers = {
      // add authentication header
      Authorization: `Bearer ${accessToken}`,
      ...(requestConfig.headers || {})
    }
  }

  return requestConfig
}

/* eslint-enable no-param-reassign */

// error handles
const REDIRECT_STATUS_CODES = [
  401 // Unauthorized
  // TODO: add back 403 check after this status code is used correctly on api-gateway side
  // 403 // Forbidden
]

const LOGIN_ENTRY_PATHS = [
  allRoutesConfig.LOGIN?.path,
  allRoutesConfig.BCC_LOGIN?.path,
  allRoutesConfig.CUDASPT_LOGIN?.path
].filter(urlPath => !!urlPath)

const REDIRECT_URLS_BLOCKLIST: string[] = LOGIN_ENTRY_PATHS
const SKIP_API_ENDPOINTS: string[] = ['/verify', '/login', '/bcc-login', '/auth0-login']

export function responseErrorInterceptor(error: any) {
  const isAllowedApiEndpoint = !SKIP_API_ENDPOINTS.some((endpoint: string) => error?.config?.url?.includes(endpoint))
  const encodedReturnUrl = encodeURIComponent(window.location.href)
  const authStore = (reduxStore.getState() as RootState).auth
  const bccLoginUrl = `${process.env.REACT_APP_GATEWAY_URL}/internal/bcc-login?return_url=${encodedReturnUrl}&account_id=${authStore.accessTokenObject?.accountId}&user_id=${authStore.accessTokenObject?.userId}`

  // logout the user if any requests failed with one of REDIRECT_STATUS_CODES and not whitelisted and blocked
  if (
    isAllowedApiEndpoint &&
    REDIRECT_STATUS_CODES.includes(error?.status) &&
    !REDIRECT_URLS_BLOCKLIST.includes(window.location.pathname)
  ) {
    if (error?.data?.detail === 'OutOfSyncCurrentAccount') {
      reauthenticate()
    } else {
      logger.info('401 returned trying to grab session from bcc')
      window.location.href = bccLoginUrl
    }
  }

  // access token is expired
  if (error?.status === 422 && error?.data?.detail === 'Signature has expired') {
    logger.info('status 422 and signature has expired returned. Trying to grab session from bcc')
    window.location.href = bccLoginUrl
  }

  return Promise.reject(error)
}

export default function registerAxiosHooks() {
  ejectRequestInterceptor()
  setRequestInterceptors(requestInterceptor)

  ejectResponseInterceptor()
  setResponseInterceptors(responseDataInterceptor, responseErrorInterceptor)
}
